import { useQuery } from '@tanstack/react-query';
import { dashboardStatsApi } from '../api/client';
import type { PlatformDashboardStats } from '../api/client';

const QUERY_KEY = 'platform-dashboard-stats';

export function useDashboardStats() {
  return useQuery<PlatformDashboardStats, Error>({
    queryKey: [QUERY_KEY],
    queryFn: () => dashboardStatsApi.getStats(),
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}
